<template>
  <div class="card" v-if="request.pendingByMe">
    <div class="card-body">
      <p class="text-header">Aceita reagendar esta sessão?</p>
      <p class="text-paragraph mb-0">
        Paciente solicitou um novo horário para esta sessão, você aceita alterar
        a data da sessão?
      </p>

      <div
        class="d-flex align-items-center py-4 border-bottom justify-content-between"
      >
        <p class="text-paragraph mb-0">Novo dia</p>
        <p class="text-subtitle mb-0">{{ request.formattedDate }}</p>
      </div>
      <div class="d-flex align-items-center py-4 justify-content-between">
        <p class="text-paragraph mb-0">Novo horário</p>
        <p class="text-subtitle mb-0">
          <TimezoneAlert icon />
          {{ request.formattedTime }}
        </p>
      </div>

      <div class="d-flex">
        <Button
          label="Rejeitar"
          outline
          :loading="rejectingReschedule"
          fullWidth
          class="me-2"
          @onClick="handleRescheduleRequest('rejected')"
        />
        <Button
          label="Aceitar"
          :loading="acceptingReschedule"
          fullWidth
          class="ms-2"
          @onClick="handleRescheduleRequest('acecpted')"
        />
      </div>
    </div>
  </div>
  <div
    v-else
    class="alert"
    :style="{ backgroundColor: request.bgColor, color: request.color }"
  >
    <div class="d-flex align-items-center mb-3">
      <i :class="`fa-solid fa-${request.icon} me-2`" />
      <p class="text-subtitle mb-0 ms-2">{{ request.title }}</p>
    </div>
    <p class="text-paragraph mb-0">
      O reagendamento desta sessão {{ request.descriptionStatus }}. O novo
      horário proposto é {{ request.descriptionDate }},
      {{ request.descriptionTime }}.
    </p>
  </div>
</template>

<script setup lang="ts">
import { useUpdateRescheduleRequest } from "@/composables/useAppointments";
import type { RescheduleRequestData } from "@phurshell/psiapp-frontend-core/domain";
import { ref } from "vue";

const props = defineProps<{ request: RescheduleRequestData }>();

const rejectingReschedule = ref(false);
const acceptingReschedule = ref(false);

const { mutateAsync: updateRescheduleRequest } = useUpdateRescheduleRequest();

async function handleRescheduleRequest(status: string) {
  try {
    acceptingReschedule.value = status === "acecpted";
    rejectingReschedule.value = status === "rejected";

    await updateRescheduleRequest({ id: props.request.id, status });
  } catch (error) {
    console.log(
      "ERRO NO HANDLE RESCHEDULE REQUEST NO APPOINTMENT DETAIL SCREEN",
      error,
    );
  } finally {
    rejectingReschedule.value = false;
    acceptingReschedule.value = false;
  }
}
</script>
